<template>
  <div class="about">
    <Header />
    <el-card class="center" shadow="never">
      <img alt="EMPIR" class="logo" src="../assets/Logo_Pollen_bleu.png">
      This web application has been developed by Pollen
      Metrology™ to normalize uploads for EMPIR partners.
    </el-card>
    <Footer fixed />
  </div>
</template>

<script>

import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'About',
  props: {
  },
  methods: {
  },
  components: {
    Header,
    Footer,
  },
}
</script>


<style lang="scss">

@import "../themes.scss";

.about {

  .center {
    .logo {
      display: inline-block;
      width: 100%;
      margin-bottom: 20px;
    }
    max-width: 400px;
    margin: auto;
  }
}

</style>
